var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvalara = function SvgAvalara(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "avalara_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".avalara_svg__st1{fill:#fc6600}")), /*#__PURE__*/React.createElement("path", {
    d: "M256.7 381.5s-25.5-31-40.4-48l-21.1 49.9c30.3 45.2 50.4 84.1 61.4 102.7 21.5-36.4 73.9-144.5 182.6-245.7l-12-28.2c-70.6 51.7-130.7 118.5-170.5 169.3",
    style: {
      fill: "#059bd2"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M414.8 500.6h86.1L425 318.9c-20.6 21.9-39.9 44.9-58 68.9zM294.5 6.8h-76L12.1 500.6h86.1l149.2-351.8 6.9-19.3h4l7.3 19.3 44.2 104.3c20.2-20.1 41.5-39.2 63.7-57.2z",
    className: "avalara_svg__st1"
  })));
};
export default SvgAvalara;